import { useQuery } from '@tanstack/vue-query'
import { inject, computed } from 'vue'

export function useSchema () {
  const $axios = inject('$axios')

  const { data } = useQuery({
    queryKey: ['schema'],
    queryFn: async () => {
      const { data } = await $axios.get('/api/schema')
      return data
    },
    staleTime: Infinity
  })

  const brandSchema = computed(() => data.value?.brand ?? null)
  const presentationSchema = computed(() => data.value?.presentation ?? null)

  return { brandSchema, presentationSchema }
}
